import { apiNWL, apiController, restartApiCotroller } from "@/utils/nwlApi";

const getCurrentStrategies = async (locId, orgId) => {
    try {
        restartApiCotroller();
        const response = await apiNWL.get(`/organisations/${orgId}/locations/${locId}/scada/events/smart-control?offset=0&limit=1&value=1`, {
            signal: apiController.signal,
        });
        return response.data.data?.[0] || {};
    } catch (error) {
        console.error(error);
    }
};

export { getCurrentStrategies };

